@if (!hideHeader()) {
  <div class="flex flex-row gap-2 items-center">
    <h3 class="grow">
      <fa-icon [icon]="faMoneyBillTrendUp"></fa-icon> Payment Detail
    </h3>
  </div>
}

<app-filter-container [filter]="filter" />

@if (loading()) {
  <app-loading></app-loading>
}

@if (currentUserId()) {
  <app-payouts-table [data]="tableData()" [userId]="currentUserId()!">
  </app-payouts-table>
}

<div
  infiniteScroll
  [infiniteScrollContainer]="scrollContainer()"
  [scrollWindow]="!scrollContainer()"
  (scrolled)="onScroll()"></div>

@if (loadingNext()) {
  <app-loading></app-loading>
}
